<script>
  import { External, M } from '../../external';

  export let contact;

  const findGroup = (groupId) => {
    return External.Website.memberGroups.find((group) => {
      return group.id === groupId;
    });
  };
  const getActiveGroups = () => {
    if (!contact.isMember()) {
      return [];
    }

    const groups = [];
    const currentAssignedGroupIds = contact.data.member.groupIds;
    currentAssignedGroupIds.forEach((groupId) => {
      const group = findGroup(groupId);
      if (group) {
        groups.push(group);
      }
    });

    return groups;
  };
  const addGroup = () => {
    if (!contact.isMember()) {
      makeMember();
      return;
    }

    const activeGroups = getActiveGroups();
    chooseMemberGroups(activeGroups, (newGroups) => {
      if (newGroups.length === 0) {
        External.Tools.showError(M.ERR_SELECT_MEMBER_GROUPS);
        return;
      }

      const newGroupIds = newGroups.map((group) => {
        return group.id;
      });

      contact.saveMemberGroups(newGroupIds);
    });
  };

  const makeMember = () => {
    chooseMemberGroups([], function (newGroups) {
      var groupIds = [];
      newGroups.forEach(function (group) {
        groupIds.push(group.id);
      });
      contact.makeMember(groupIds);
    });
  };

  const chooseMemberGroups = (currentlyAssignedGroups, onSelect) => {
    External.Tools.chooseMultiple({
      title: M.SELECT_MEMBER_GROUPS,
      message: '',
      noItemsMessage: M.NO_MEMBER_GROUPS,
      items: External.Website.memberGroups,
      selectedItems: currentlyAssignedGroups,
      isModal: true,
      getItemId: function (group) {
        return group.id;
      },
      getItemText: function (group) {
        return group.name;
      },
      onSelect: onSelect
    });
  };

  const removeGroup = (groupId) => {
    if (!contact.isMember()) {
      return;
    }

    if (contact.data.member.groupIds.length === 1) {
      External.Tools.showError(M.ERR_AT_LEAST_ONE_MEMBER_GROUP);
      return;
    }

    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, function () {
      const updatedGroupIds = contact.data.member.groupIds.filter((id) => {
        return id !== groupId;
      });
      contact.saveMemberGroups(updatedGroupIds);
    });
  };

  const approveDeny = (approve) => {
    if (!contact.isMember()) {
      return;
    }

    contact.approveDenyMember(approve);
  };

  const resetPassword = () => {
    if (!contact.isMember()) {
      return;
    }

    External.Tools.prompt(M.DEL_CONFIRM, M.PASSWORD_RESET_CONFIRM, contact.resetMemberPassword);
  };
</script>

<section data-role="member-info">
  <div class="col20 mt-5 f-left">
    {#if !contact.isMember()}
      <div class="col20">
        <label>
          <h5>{M.NOT_A_MEMBER}</h5>
        </label>
      </div>
    {/if}
    <div class="col20 mt-10">
      <a class="small-button with-icon blue f-left ml-0 rounded-effect" on:click={addGroup}>{contact.isMember() ? M.ADD_MEMBER_GROUP_TITLE : M.MAKE_WEBSITE_MEMBER}</a>
    </div>
    <div class="col20 mt-10 membership-groups-wrapper f-left">
      {#if contact.isMember()}
        {#each contact.data.member.groupIds as groupId}
          <div class="filter-option">
            <span>{findGroup(groupId).name}</span>
            <a
              class="filter-delete"
              on:click={() => {
                removeGroup(groupId);
              }}>
              <svg
                height="10px"
                id="Capa_1"
                version="1.1"
                viewBox="0 0 357 357"
                width="10px"
                x="0px"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                y="0px">
                <polygon
                  points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"
                ></polygon>
              </svg>
            </a>
          </div>
        {/each}
      {:else}{/if}
    </div>
  </div>
  {#if contact.isMember()}
    <div class="col20 f-left contact-details">
      <label class="col20 f-left">
        <h5>{M.REGISTERED_ON}</h5>
        <span class="col20 f-left" data-role="regDate">
          {External.Tools.dateToString(new Date(contact.data.member.registeredOn))}
        </span>
      </label>
      <label class="col20 f-left mt-10">
        <h5>{M.LAST_LOGIN}</h5>
        <span class="col20 f-left" data-role="lastLoginDate">
          {contact.data.member.lastLogin ? External.Tools.dateToString(new Date(contact.data.member.lastLogin)) : '-'}
        </span>
      </label>
      <label class="col20 f-left mt-10">
        <h5>{M.SHIPPING_ADDRESS}</h5>
        <span class="col20 f-left" data-role="shippingAddr">
          {@html External.Tools.addrToStr(null, contact.data.member.shippingAddress) === ''
            ? '-'
            : External.Tools.addrToStr(null, contact.data.member.shippingAddress)}
        </span>
      </label>
      <label class="col20 f-left mt-10">
        <h5>{M.BILLING_ADDRESS}</h5>
        <span class="col20 f-left" data-role="billingAddr">
          {@html External.Tools.addrToStr(null, contact.data.member.billingAddress) === ''
            ? '-'
            : External.Tools.addrToStr(null, contact.data.member.billingAddress)}
        </span>
      </label>
    </div>
    <div class="profile-section t-center">
      <a
        class="gray middle-button"
        on:click={() => {
          resetPassword();
        }}
        style="margin-top: 15px;">{M.RESET_PASSWORD}</a>
    </div>
    <div
      class:none={contact.data.member.approved}
      class="approve-buttons flex"
      style="width: 100%; place-content: space-evenly;">
      <a
        class="green middle-button"
        on:click={() => {
          approveDeny(true);
        }}>{M.APPROVE}</a>
      <a
        class="red middle-button"
        on:click={() => {
          approveDeny(false);
        }}>{M.DENY}</a>
    </div>
  {/if}
</section>
